import * as React from 'react';

export default function FaceIdIcon({
  className,
  pathClassName,
}: {
  className?: string;
  pathClassName?: string;
}) {
  return (
    <svg fill="none" viewBox="0 0 24 25" className={className}>
      <path
        className={pathClassName}
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.219 7.27V4.575A2.675 2.675 0 0 1 3.89 1.903h2.695a.61.61 0 0 0 0-1.219H3.89A3.895 3.895 0 0 0 0 4.574V7.27a.61.61 0 0 0 1.219 0Zm5.367 16.195a.61.61 0 1 1 0 1.22H3.89A3.895 3.895 0 0 1 0 20.793v-2.696a.61.61 0 0 1 1.219 0v2.696a2.675 2.675 0 0 0 2.672 2.671h2.695ZM24 18.098v2.696a3.895 3.895 0 0 1-3.89 3.89h-2.696a.61.61 0 1 1 0-1.219h2.695a2.675 2.675 0 0 0 2.672-2.671v-2.696a.61.61 0 0 1 1.219 0Zm0-13.523V7.27a.61.61 0 1 1-1.219 0V4.575a2.675 2.675 0 0 0-2.672-2.672h-2.695a.61.61 0 1 1 0-1.219h2.695A3.895 3.895 0 0 1 24 4.574Zm-7.795 13.847a.633.633 0 0 0-.858-.93A4.918 4.918 0 0 1 12 18.803a4.918 4.918 0 0 1-3.347-1.31.633.633 0 0 0-.858.93A6.18 6.18 0 0 0 12 20.067a6.18 6.18 0 0 0 4.205-1.645Zm-2.94-8.691v4.5c0 .892-.725 1.617-1.617 1.617h-.515a.633.633 0 1 1 0-1.265h.515A.352.352 0 0 0 12 14.23v-4.5a.633.633 0 1 1 1.266 0Zm4.36 1.77V9.696a.598.598 0 0 0-1.195 0V11.5a.598.598 0 1 0 1.195 0Zm-11.11 0a.598.598 0 1 0 1.196 0V9.696a.598.598 0 0 0-1.195 0V11.5Z"
        fill="#fff"
      />
    </svg>
  );
}
